import { Space, Typography, Row, Col } from "antd";
import React, { useEffect, useState } from "react";
import {
  BankOutlined,
  CloudDownloadOutlined,
  AudioOutlined,
} from "@ant-design/icons";
import StaticCard from "../Card/StaticCard";
import PieChart from "../Chart.js/PieChart";
import LineChart from "../Chart.js/LineChart";

function Overview() {
  const [userList, setUserList] = useState([]);
  const [songList, setSongList] = useState([]);
  const [publisherList, setPublisherList] = useState([]);
  const [userCountThisMonth, setUserCountThisMonth] = useState(0);
  const [songCountThisMonth, setSongCountThisMonth] = useState(0);
  const [pieData, setPieData] = useState([]);
  const [pieData1, setPieData1] = useState([]);
  const lineData = [
    { month: "Jan", revenue: 500 },
    { month: "Feb", revenue: 800 },
    { month: "Mar", revenue: 600 },
    { month: "Apr", revenue: 1000 },
    { month: "May", revenue: 1200 },
  ];

  const fetchUserList = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/admin/getAllUsers`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setUserList(data);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };
  const fetchPublisherList = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/admin/getPublisher`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setPublisherList(data);
    } catch (error) {
      console.error("Error fetching artist list:", error);
    }
  };
  const fetchSongList = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/admin/getAllTracks`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setSongList(data);
    } catch (error) {
      console.error("Error fetching song list:", error);
    }
  };

  const countItemsThisMonth = (items, dateField) => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // 0-indexed

    let count = 0;
    items.forEach((item) => {
      const date = new Date(item[dateField]);
      const itemYear = date.getFullYear();
      const itemMonth = date.getMonth();

      if (itemYear === currentYear && itemMonth === currentMonth) {
        count++;
      }
    });
    return count;
  };

  const generatePieData = (users) => {
    let normalCount = 0;
    let premiumCount = 0;

    users.forEach((user) => {
      // Assuming your user object has an 'isPro' property (boolean).  Rename if needed.
      if (user.isPro) {
        premiumCount++;
      } else {
        normalCount++;
      }
    });

    return [
      { type: "Normal", value: normalCount },
      { type: "Premium", value: premiumCount },
    ];
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchUserList();
      await fetchSongList();
      await fetchPublisherList();
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (userList.length > 0) {
      const userCount = countItemsThisMonth(userList, "createdAt");
      setUserCountThisMonth(userCount);
      const pieData = generatePieData(userList);
      setPieData(pieData);
    }

    if (songList.length > 0) {
      const songCount = countItemsThisMonth(songList, "createdAt");
      setSongCountThisMonth(songCount);
    }
  }, [userList, songList]);
  const myLabelMap = {
    Normal: "Free Users",
    Premium: "Pro Users",
  };

  const calculateUserAndArtistCounts = async () => {
    try {
      const filteredUserList = userList.filter(
        (user) => user.role !== "admin" && user.role !== "censor"
      );

      const publisherCount = publisherList.length;
      const userCount = filteredUserList.length; // Use the filtered user list
      const listenerCount = userCount - publisherCount;
      return [
        { type: "Nghệ sĩ", value: publisherCount },
        { type: "Thính giả", value: listenerCount },
      ];
    } catch (error) {
      console.error("Error calculating counts:", error);
      return [
        { type: "Nghệ sĩ", value: 0 },
        { type: "Thính giả", value: 0 },
      ];
    }
  };
  const myLabelMap1 = {
    Publishers: "Nghệ sĩ",
    Listeners: "Thính giả",
  };

  useEffect(() => {
    const getCounts = async () => {
      try {
        const data = await calculateUserAndArtistCounts();
        setPieData1(data);
      } catch (error) {
        console.error("Error fetching and setting pie data:", error);
        setPieData1([]);
      }
    };

    getCounts();
  }, [userList, publisherList]);
  return (
    <div>
      <Typography.Title level={3}>Overview</Typography.Title>
      <Space>
        <Row gutter={16} align="top">
          <Col span={18}>
            <Row gutter={16}>
              <Col span={6}>
                <StaticCard
                  cardColor="#FF919D"
                  textColor="#242d49"
                  iconColor="#242d49"
                  title="New Tracks"
                  amount={songCountThisMonth.toString()}
                  time="This month"
                  icon={<AudioOutlined />}
                />
              </Col>
              <Col span={6}>
                <StaticCard
                  cardColor="#FF919D"
                  textColor="#242d49"
                  iconColor="#242d49"
                  title="New Users"
                  amount={userCountThisMonth.toString()}
                  time="This month"
                  icon={<BankOutlined />}
                />
              </Col>
              <Col span={6}>
                <StaticCard
                  cardColor="#FF919D"
                  textColor="#242d49"
                  iconColor="#242d49"
                  title="Downloads"
                  amount="100,000"
                  time="This month"
                  icon={<CloudDownloadOutlined />}
                />
              </Col>
              <Col span={6}>
                <StaticCard
                  cardColor="#FF919D"
                  textColor="#242d49"
                  iconColor="#242d49"
                  title="Earnings"
                  amount="$100,000"
                  time="This month"
                  icon={<AudioOutlined />}
                />
              </Col>

              <Col span={24}>
                <LineChart
                  data={lineData}
                  xField="month"
                  yField="revenue"
                  title="Monthly Revenue"
                  height={430}
                  width={800}
                />
              </Col>
            </Row>
          </Col>

          <Col span={6}>
            <Row style={{ marginBottom: "20px" }}>
              <PieChart
                data={pieData}
                title="User Type"
                labelMap={myLabelMap}
              />
            </Row>
            <Row>
              <PieChart
                data={pieData1}
                title="Nhóm người dùng"
                labelMap={myLabelMap1}
              />
            </Row>
          </Col>
        </Row>
      </Space>
    </div>
  );
}

export default Overview;
